/**
 * Configuration d'exécution de la SPA.
 *
 * Toutes les variables sont préfixées `VITE_` : Vite n'injecte que celles-là
 * dans le bundle, ce qui empêche une variable serveur de fuiter côté client.
 */
export interface AppConfig {
  env: string
  /** Origine de l'API, SANS le préfixe `/api` (porté par les chemins OpenAPI). */
  apiOrigin: string
  sentry: { dsn: string; environment: string }
}

export const config: AppConfig = {
  env: import.meta.env.MODE,
  apiOrigin: import.meta.env.VITE_API_ORIGIN ?? 'http://localhost:10002',
  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN ?? '',
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.MODE,
  },
}
